import get from 'lodash/get';
import moment from 'moment';
import api from '../lib/api';
import { SNACKBAR_ERROR } from './snackbar';

export const FETCH_DEPLOYMENT_REPORT = 'FETCH_DEPLOYMENT_REPORT';
export const FETCH_DEPLOYMENT_EVENTS = 'FETCH_DEPLOYMENT_EVENTS';
export const FETCH_REPAIR_TICKET_REPORT = 'FETCH_REPAIR_TICKET_REPORT';
export const FETCH_REPAIR_TICKETS_FOR_AGGREGATION_REPORT = 'FETCH_REPAIR_TICKETS_FOR_AGGREGATION_REPORT';
export const FETCH_INVENTORY_REPORT = 'FETCH_INVENTORY_REPORT';
export const IS_LOADING = 'IS_LOADING';
export const IS_REPORT_CSV_LOADING = 'IS_REPORT_CSV_LOADING';
export const FETCH_RIDE_REPORT = 'FETCH_RIDE_REPORT';

export default {
  fetchDeploymentEvents(query) {
    return (dispatch) => {
      dispatch({ type: IS_LOADING, payload: true });
      return api
        .getDeploymentEvents(query)
        .then((reports) => {
          dispatch({ type: FETCH_DEPLOYMENT_EVENTS, payload: { reports, query } });
        })
        .then(() => {
          dispatch({ type: IS_LOADING, payload: false });
        })
        .catch(() => {
          dispatch({ type: IS_LOADING, payload: false });
        });
    };
  },
  fetchDeploymentTasks(query) {
    return (dispatch) => api
      .getDeploymentTasks(query)
      .then((tasks) => {
        const marketId = get(query, 'market_id');
        const date = moment(get(query, 'date'), 'x');
        dispatch({ type: FETCH_DEPLOYMENT_REPORT, payload: { tasks, marketId, date } });
      })
      .then(() => {
        dispatch({ type: IS_LOADING, payload: false });
      })
      .catch(() => {
        dispatch({ type: IS_LOADING, payload: false });
      });
  },
  fetchRepairTicketReport(query) {
    return (dispatch) => {
      dispatch({ type: IS_LOADING, payload: true });

      return api
        .getRepairTicketReport(query)
        .then((data) => dispatch({ type: FETCH_REPAIR_TICKET_REPORT, payload: data }))
        .then(() => dispatch({ type: IS_LOADING, payload: false }))
        .catch(() => dispatch({ type: IS_LOADING, payload: false }));
    };
  },
  fetchRepairTicketsForAggregationReport(query) {
    return (dispatch) => {
      dispatch({ type: IS_LOADING, payload: true });

      return api
        .getRepairTicketsForAggregation(query)
        .then((data) => dispatch({
          type: FETCH_REPAIR_TICKETS_FOR_AGGREGATION_REPORT, payload: data,
        }))
        .then(() => dispatch({ type: IS_LOADING, payload: false }))
        .catch(() => dispatch({ type: IS_LOADING, payload: false }));
    };
  },
  fetchRideReportData(query) {
    return (dispatch) => {
      dispatch({ type: IS_LOADING, payload: true });

      return api
        .getRideReportData(query)
        .then((data) => dispatch({ type: FETCH_RIDE_REPORT, payload: data }))
        .then(() => dispatch({ type: IS_LOADING, payload: false }))
        .catch(() => dispatch({ type: IS_LOADING, payload: false }));
    };
  },
  fetchAndDownloadRideReportCsv(query) {
    return (dispatch) => {
      dispatch({ type: IS_REPORT_CSV_LOADING, payload: true });

      api
        .getRideReportData(query)
        .then((data) => {
          dispatch({ type: IS_REPORT_CSV_LOADING, payload: false });

          // taken from https://stackoverflow.com/questions/41938718/how-to-download-files-using-axios
          const url = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'wrangler-trip-report.csv');
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          dispatch({ type: IS_REPORT_CSV_LOADING, payload: false });
          dispatch({ type: SNACKBAR_ERROR, message: `Error downloading csv: ${error.message}` });
        });
    };
  },
  fetchInventoryReport(query) {
    return (dispatch) => {
      dispatch({ type: IS_LOADING, payload: true });

      return api
        .getInventoryReport(query)
        .then((data) => dispatch({ type: FETCH_INVENTORY_REPORT, payload: data }))
        .then(() => dispatch({ type: IS_LOADING, payload: false }))
        .catch(() => dispatch({ type: IS_LOADING, payload: false }));
    };
  },
};
